import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-business-access-form',
  templateUrl: './business-access-form.component.html',
  styleUrls: ['./business-access-form.component.scss']
})
export class BusinessAccessFormComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }
}
